import { useState } from "react";
import { Box, Button, Stack, TextField, Typography } from "@mui/material";

import { useDispatch } from "react-redux";
import { useDialogs } from "@toolpad/core/useDialogs";

import { store } from "@store/store";
import { Notificacion } from "./Notificacion";
import { OfferActionDialogProps } from "@interfaces/slices";
import { setDialogConfig } from "@store/slices/componentsSlice";
import { useLazyGetModulesByCodeQuery } from "@services/api/roles";
import { usePostCommentByAppMutation } from "@services/api/applications";

export const Ofertar = (props: OfferActionDialogProps) => {
    const dialogs = useDialogs();
    const dispatch = useDispatch();

    const [reason, setReason] = useState<string>("");
    const [savingOffer, setSavingOffer] = useState<boolean>(false);
    const [disableConfirmBtn, setDisableConfirmBtn] = useState<boolean>(true);

    const sessionInfo = (state = store.getState()) => state.app.session;
    const applicationSelected = (state = store.getState()) => state.app.applicationSelected;

    const [triggerPostComment] = usePostCommentByAppMutation();
    const [triggerGetModulesByCode] = useLazyGetModulesByCodeQuery();

    const handleOnReasonChanged = (e: any) => {
        setReason(e.target.value);
        setDisableConfirmBtn(e.target.value.trim().length === 0);
    };

    const handleOnRejectClicked = () => {
        dispatch(setDialogConfig());
    };

    const handleOnConfirmClicked = async () => {
        try {
            setSavingOffer(true);
            if (props.type === "OFFER") {
                props.onAcceptClick(props.type);
                return;
            }
            const module = await triggerGetModulesByCode("SBOFER").unwrap();

            await triggerPostComment({
                applicationId: applicationSelected(store.getState()).id ?? "0-0-0-0-0",
                payload: {
                    user_id: sessionInfo(store.getState()).user.id,
                    comment: reason,
                    module_id: module?.id,
                },
            }).unwrap();

            props.onAcceptClick(props.type);
            setSavingOffer(false);
        } catch (error) {
            await dialogs.open(Notificacion, {
                type: "WARNING",
                text: "No se pudo guardar la oferta, intente de nuevo.",
            });
        }
    };

    return (
        <Box margin={4} minWidth={350}>
            <Stack textAlign={"center"} rowGap={2}>
                <Typography component={"span"} variant="body1" fontWeight={600} color="main3">
                    Está seguro que quiere{" "}
                    {props.updated ? (
                        "actualizar la oferta de:"
                    ) : (
                        <>
                            <Typography
                                component={"span"}
                                variant="body1"
                                fontWeight={600}
                                color={props.type === "OFFER" ? "secondary4" : "secondary3"}
                            >
                                {props.type === "OFFER" ? "ofertar" : "rechazar"}
                            </Typography>{" "}
                            por:
                        </>
                    )}
                </Typography>
                <Typography variant="body1" fontWeight={600} color="main2">
                    {applicationSelected(store.getState()).comercial_name}
                </Typography>
                <Typography component={"span"} variant="body1" color="main2">
                    ID SOLICITUD:
                    <Typography component={"span"} variant="body1" color="main2" fontWeight={600}>
                        {applicationSelected(store.getState()).id_application_company}
                    </Typography>
                </Typography>

                <TextField
                    multiline
                    rows={5}
                    fullWidth
                    required
                    label={"Breve descripción del motivo"}
                    onChange={handleOnReasonChanged}
                />
            </Stack>
            <Stack direction={"row"} justifyContent={"space-around"} mt={4}>
                <Button variant="blue_outlined" onClick={handleOnRejectClicked}>
                    Regresar
                </Button>
                <Button
                    variant="contained"
                    color={props.type === "OFFER" ? "secondary4" : "secondary3"}
                    onClick={handleOnConfirmClicked}
                    disabled={disableConfirmBtn || savingOffer}
                    loading={savingOffer}
                >
                    {props.type === "OFFER" ? "Ofertar" : "Rechazar"}
                </Button>
            </Stack>
        </Box>
    );
};
